<template>
  <div :v-show="menu">
    <div class="w-full vx-col mb-base">
      <vs-card title="Menu" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <h4 style="margin-left: 10px">Latest APK Courier Mobile</h4>
          </div>

          <div class="flex items-center">
            <vs-button
              :to="{ name: 'couriermanagement-list'}"
              class="mb-4 mr-1 md:mb-0"
              icon="remove_red_eye"
            >View Archive APK</vs-button>
          </div>
        </div>
        <div class="mt-6 vx-row">
          <div class="w-full vx-col lg:w-1/2">
            <div class="mb-3 vx-row">
              <div class="w-1/3 vx-col">Version Number *</div>
              <div class="w-2/3 vx-col">
                <vs-input class="w-full" v-model="menu.version_number" disabled />
              </div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-1/3 vx-col">Version Code</div>
              <div class="w-2/3 vx-col">
                <vs-input class="w-full" v-model="menu.version_code" disabled />
              </div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-1/3 vx-col">Force Update</div>
              <div class="w-2/3 vx-col">
                <vs-input class="w-full" v-model="menu.force_update" disabled />
              </div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-1/3 vx-col">Update Notes *</div>
              <div class="w-2/3 vx-col">
                <vs-textarea class="w-full" height="100"  v-model="menu.update_notes" disabled />
              </div>
            </div>
          </div>

          <div class="w-full vx-col lg:w-1/2">
            <div class="mb-3 vx-row">
              <div class="w-1/5 vx-col"></div>
              <div class="w-3/5 vx-col"><strong>Download APK</strong></div>
              <div class="w-1/5 vx-col"></div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-1/5 vx-col"></div>
              <div class="w-3/5 vx-col">
                <img v-bind:src="'data:image/jpeg;base64,'+ menu.qrcode" />
              </div>
              <div class="w-1/5 vx-col"></div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      menu: {
        file_names:"",
        update_notes: "",
        version_number: "",
        version_code: "",
        qrcode: "",
        force_update: "",
      },
      parents: [],
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    fetchData() {
      this.$http.get("courier/getlatestapk").then((res) => {
            this.menu.version_number = res.data.version_number;
            this.menu.version_code = res.data.version_code;
            this.menu.update_notes = res.data.update_notes;
            this.menu.qrcode = res.data.qrcode;
            this.menu.force_update = res.data.force_update;
        });
    },
    back() {
      this.$router.push({ name: "couriermanagement" });
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>
